import React from 'react';
import './TeamCard.css';
import api from '../services/api';
import { getLogoSrc } from '../utils/logoHelper';
import { useNavigate } from 'react-router-dom';

// Add this at the top to get the correct API URL
const API_BASE_URL = api.defaults.baseURL.replace('/api', '');

function TeamCard({
  team,
  isLocked = false,
  onUpgradeClick,
  subscriptionPlan,
  onClick,
  isSelected,
}) {
  const navigate = useNavigate();

  // Hide logos for free users (both locked and unlocked teams)
  const shouldShowLogo = team.logoUrl && subscriptionPlan !== 'free';

  return (
    <div
      className={`team-card ${isLocked ? 'locked' : ''} ${
        isSelected ? 'selected' : ''
      }`}
      onClick={!isLocked ? onClick : undefined}
      style={{ cursor: !isLocked ? 'pointer' : 'default' }}
    >
      <div
        className="team-header"
        style={{
          background: `linear-gradient(135deg, ${team.primaryColor} 0%, ${team.secondaryColor} 100%)`,
        }}
      >
        <div className="team-logo">
          {shouldShowLogo ? (
            <img
              src={getLogoSrc(team.logoUrl, API_BASE_URL)}
              alt={`${team.name} logo`}
              className="team-logo-img"
            />
          ) : (
            <span className="team-logo-fallback">
              {team.sport === 'Softball' ? '🥎' : '⚾'}
            </span>
          )}
        </div>
      </div>

      <div className="team-info">
        <div className="team-name-row">
          <h3 className="team-name">{team.name}</h3>
          {team.isAssignedCoach && team.orgAcronym && (
            <span className="org-badge assigned-coach">
              Assigned Coach - {team.orgAcronym}
            </span>
          )}
          {!team.isAssignedCoach &&
            team.organizationTeam &&
            team.orgAcronym && (
              <span className="org-badge org-admin">{team.orgAcronym}</span>
            )}
        </div>

        <div className="team-details">
          <div className="detail-item">
            <span className="detail-label">Sport:</span>
            <span className="detail-value">{team.sport}</span>
          </div>

          <div className="detail-item">
            <span className="detail-label">Age Group:</span>
            <span className="detail-value">{team.ageGroup}</span>
          </div>

          <div className="detail-item">
            <span className="detail-label">Season:</span>
            <span className="detail-value">{team.season}</span>
          </div>
        </div>

        <div className="team-colors">
          <div className="color-swatch-group">
            <div
              className="color-swatch"
              style={{ backgroundColor: team.primaryColor }}
              title={`Primary: ${team.primaryColor}`}
            />
            <div
              className="color-swatch"
              style={{ backgroundColor: team.secondaryColor }}
              title={`Secondary: ${team.secondaryColor}`}
            />
          </div>
        </div>
      </div>

      {isLocked ? (
        <div className="team-locked-overlay">
          <div className="locked-content">
            <span className="lock-icon-large">🔒</span>
            <p className="locked-message">Upgrade to access this team</p>
            <button className="btn btn-upgrade" onClick={onUpgradeClick}>
              ⭐ Upgrade Now
            </button>
          </div>
        </div>
      ) : (
        <div className="team-actions">
          <button
            className="btn btn-primary"
            onClick={() => navigate(`/edit-team/${team.id}`)}
          >
            Edit Team
          </button>
          <button
            className="btn btn-primary"
            onClick={() => navigate(`/create-graphic?teamId=${team.id}`)}
          >
            Create Graphic
          </button>
        </div>
      )}
    </div>
  );
}

export default TeamCard;
